import { memo, ReactNode } from "react";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";
import {
  BackButton,
  StyledLoggedOutLayoutContent,
  StyledLoggedOutLayoutFooter,
  StyledLoggedOutLayoutLogo,
  StyledLoggedOutLayoutNav,
  StyledLoggedOutLayoutWrapper,
} from "./LoggedOutLayout.elements";
import { ICONS } from "../../icons";
import { useTranslation } from "react-i18next";

export interface LoggedOutLayoutProps {
  children?: ReactNode;
  onBack?: (() => void) | null;
}

export function LoggedOutLayout({ children, onBack }: LoggedOutLayoutProps) {
  const { t } = useTranslation();
  return (
    <StyledLoggedOutLayoutWrapper>
      <StyledLoggedOutLayoutNav>
        {typeof onBack === "function" && (
          <BackButton type="button" onClick={onBack}>
            {t("common.button.back")}
          </BackButton>
        )}
        <div style={{ opacity: "0" }}></div>
        <StyledLoggedOutLayoutLogo
          src={ICONS.BlockBenLightLogo}
          alt="BlockBen Logo"
        />
        <LanguageSelector />
      </StyledLoggedOutLayoutNav>
      <StyledLoggedOutLayoutContent>{children}</StyledLoggedOutLayoutContent>
      <StyledLoggedOutLayoutFooter></StyledLoggedOutLayoutFooter>
    </StyledLoggedOutLayoutWrapper>
  );
}

export default memo(LoggedOutLayout);
